import { Module } from 'vuex';
import { defaultInProgressData } from '@/features/common/raw';
import { Shipment } from '../types';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const shipment: Module<Shipment, any> = {
  state: {
    showNotification: true,
    showSummaryPage: false,
    availableServices: null,
    reconnectAccountRequired: null,
    addressBook: [],
    selectedService: null,
    inProgress: JSON.parse(JSON.stringify(defaultInProgressData)),
    isInProgressData: 0,
    isInProgressDataChanged: false,
    storesForImport: [],
    secureshipTrackingNo: '',
    whereShipmentForm: null,
    whatShipmentForm: null,
    generalInfoForm: null,
  },
  mutations,
  getters,
  actions,
};

export default shipment;
